<template>
    <div class="space-y-2">
        <form class="flex gap-2" @submit.prevent="submit">
            <label for="newsletter-email" class="sr-only">{{ $t('Enter your email address') }}</label>
            <input id="newsletter-email" v-model="email" type="email" name="email" autocomplete="email" :placeholder="$t('Enter your email address')" class="flex-1" required :disabled="loading" />

            <button type="submit" class="btn btn-primary btn-md" :disabled="loading || !email">
                {{ $t('Subscribe') }}
            </button>
        </form>

        <Message v-if="feedback.message" :severity="feedback.type">
            {{ feedback.message }}
        </Message>

        <p class="text-sm" v-html="$t('Terms agreement')"></p>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useAsyncRequest } from '@/composables/useAsyncRequest'

const { t } = useI18n()
const { post, loading } = useAsyncRequest()

const email = ref('')
const feedback = ref({
    type: '',
    message: '',
})

let resetTimer = null

const setFeedback = (type, message) => {
    feedback.value = { type, message }

    clearTimeout(resetTimer)
    resetTimer = setTimeout(() => {
        feedback.value = { type: '', message: '' }
        resetTimer = null
    }, 5000)
}

const submit = async () => {
    if (loading.value) return

    feedback.value = { type: '', message: '' }
    clearTimeout(resetTimer)

    try {
        await post('/api/newsletter/subscribe', { email: email.value })

        email.value = ''
        setFeedback('success', t('Thank you for subscribing.'))
    } catch (e) {
        setFeedback('error', e?.response?.data?.message || t('Subscription failed. Please try again.'))
    }
}

onBeforeUnmount(() => {
    clearTimeout(resetTimer)
})
</script>
